/* eslint-disable react/require-default-props */
import React from 'react';

import Card from '/component/base/Card';
import Text from '/component/base/Text';
import {HealthJourneyTestIds} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';
import testProperties from '/util/testing/testProperties';

import {styles} from './WhyFooter.style';

interface WhyFooterProps {
  myWhy?: {
    myWhy: string;
  };
  mwlData: {};
  firstName: string;
}

export const WhyFooter: React.FC<WhyFooterProps> = ({
  myWhy,
  firstName,
  mwlData,
}) => {
  const {ts} = useTranslation('component.partial.whyFooter');

  let myWhyText;
  mwlData === true //If a client has shared and not added a Mywhy ( in short if we are getting true value in coach-sharing API)
    ? (myWhyText = myWhy?.myWhy || 'Not updated')
    : (myWhyText = myWhy?.myWhy || '--');

  const clientName = firstName || '';

  return (
    <Card style={styles.cardContainer}>
      <Text
        isBold
        style={styles.titleText}
        {...testProperties(HealthJourneyTestIds.clientWhyLabel)}>
        {ts('title.Footer', `${clientName}'s why:`)}
      </Text>
      <Text
        style={styles.description}
        {...testProperties(HealthJourneyTestIds.clientWhyValue)}>
        {ts('title.planDescription', myWhyText)}
      </Text>
    </Card>
  );
};

export default WhyFooter;
